import request from '@/utils/request'

/**
 * 查询系统元件
 * @param {Object} params 
 * @returns 
 */
export function listSysComponent(params) {
  return request({
    url: '/component/sys_component/list',
    method: 'GET',
    params,
  })
}

/**
 * 添加系统元件
 * @param {Object} data 
 * @returns 
 */
export function insertSysComponent(data) {
  return request({
    url: '/component/sys_component/insert',
    method: 'POST',
    data,
  })
}


/**
 * 修改系统元件
 * @param {Object} data 
 * @returns 
 */
export function updateSysComponent(data) {
  return request({
    url: '/component/sys_component/update',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function removeSysComponent(data) {
  return request({
    url: '/component/sys_component/remove',
    method: 'POST',
    data,
  })
}


/**
 * 添加系统元件
 * @param {Object} data 
 * @returns 
 */
export function getSysComponentById(data) {
  return request({
    url: '/component/sys_component/getById',
    method: 'get',
    data,
  })
}

